import React from "react";
import { Button } from "antd";
import { Trash2, Image as ImageIcon } from "lucide-react";

function ElementoImagem({ imagem, onRemove }) {
  const getImageSrc = () => {
    if (imagem.isExistente) {
      return `${process.env.REACT_APP_BACKEND_LINK}/${imagem.urlExistente}`;
    } else {
      return imagem.preview;
    }
  };

  const getImageSize = () => {
    if (imagem.isExistente) {
      return "Imagem existente";
    } else {
      return `${Number((imagem.file.size / 1024 / 1024).toFixed(2))}MB`;
    }
  };

  const getTipoDisplay = () => {
    return imagem.tipo === "cabecalho" ? "Cabeçalho" : "Rodapé";
  };

  return (
    <div
      style={{
        border: "1px solid #d9d9d9",
        borderRadius: "6px",
        padding: "12px",
        backgroundColor: "#fafafa",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
        }}
      >
        {/* Preview da Imagem */}
        <div
          style={{
            width: "80px",
            height: "60px",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            overflow: "hidden",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <img
            src={getImageSrc()}
            alt={getTipoDisplay()}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
            onError={(e) => {
              // Se a imagem não carregar, mostrar ícone
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
          <div
            style={{
              display: "none",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              color: "#999",
            }}
          >
            <ImageIcon size={24} />
          </div>
        </div>

        {/* Informações da Imagem */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              marginBottom: "4px",
            }}
          >
            {getTipoDisplay()}
          </div>

          <div
            style={{
              fontSize: "12px",
              color: "#666",
              marginBottom: "8px",
            }}
          >
            {getImageSize()}
          </div>

          {!imagem.isExistente && imagem.file && (
            <div
              style={{
                fontSize: "12px",
                color: "#999",
              }}
            >
              {imagem.file.name}
            </div>
          )}
        </div>

        {/* Botão de Remover */}
        <Button
          type="text"
          danger
          icon={<Trash2 size={16} />}
          onClick={onRemove}
          style={{
            flexShrink: 0,
          }}
        >
          Remover
        </Button>
      </div>
    </div>
  );
}

export default ElementoImagem;
